import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface History {
  action?: {
    actionType: string;
    additionalInfo: {
      authType: null;
      email: string;
      failureCount: number | null;
      participantName: string;
      phoneNumber: string | null;
      signingMethodType: 'email' | 'kakao';
    } | null;
  };
  actionGenerator: {
    actionGeneratorType: string | null;
    name: string | null;
    participantEmail: string | null;
    participantId: string | null;
    participantPhoneNumber: string | null;
    requesterEmail: string | null;
    signingMethodType: string | null;
    userAgent: string | null;
    userIp: string | null;
  };
  content: string;
  timestamp: string;
}

export interface DocumentsHistoriesResponse {
  histories: History[];
}

// eslint-disable-next-line import/prefer-default-export
export function getDocumentsHistories({
  documentId,
  workspaceId,
}: {
  workspaceId: string;
  documentId: string;
}): Promise<History[]> {
  return requestApi<DocumentsHistoriesResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/histories`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data.histories);
}
